{
  "Add to profile": "Add to completed",
  "What did I learn": "What is your main takeaway?",
  "Time spent": "Time",
  "Learning has been added": "Learning has been added",
  "Learning has been updated": "Learning has been updated",
  "Learning has been removed": "Learning has been removed",
  "Provided time is not valid": "Provided time is not valid",
  "Link needs to be a valid URL": "Link needs to be a valid URL",
  "Provided time must be greater or equal to 0": "Provided time must be greater or equal to 0",
  "Provided time must be less than or equal to 50 hours": "Provided time must be less than or equal to 50 hours",
  "Provided time must be an integer": "Provided time must be an integer",
  "Type": "Learning type"
}
